export default __webpack_public_path__ + "static/media/input-uncheck.4d2b7ca0.svg";